export function formatIBAN(value: string): string {
  const cleaned = value.replace(/\s+/g, '');
  const formatted = cleaned.match(/.{1,4}/g);
  return formatted ? formatted.join(' ') : cleaned;
}

export function unformatIBAN(value: string): string {
  return value.replace(/\s+/g, '');
}
